const translations = {
  "en": {
    "Display only auto-renewing subscriptions": "Display only auto-renewing subscriptions",
    "Invoices": "Invoices",
    "Manage Billing": "Manage Billing",
    "Manage Subscription": "Manage Subscription"
  },
  "zh-tw": {
    "Display only auto-renewing subscriptions": "僅顯示自動續訂項目",
    "Invoices": "發票",
    "Manage Billing": "管理帳單",
    "Manage Subscription": "管理訂閱"
  }
};

export default translations;
